(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPrivacyPracticeComponent', agreementPrivacyPracticeComponent);

    agreementPrivacyPracticeComponent.$inject = [];

    function agreementPrivacyPracticeComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPrivacyPracticeController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-privacy-practice.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPrivacyPracticeController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPrivacyPracticeController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
